module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    staticClass: "mb-2 card-danger cardhead",
    attrs: {
      "header": "Task To-Do"
    }
  }, _vm._l((_vm.todos), function(todo, index) {
    return _c('b-card', {
      key: todo.id,
      staticClass: "mb-2 cardcontent",
      attrs: {
        "header": todo.task
      }
    }, [_c('p', [_vm._v("(" + _vm._s(todo.point) + ") Assigned to: " + _vm._s(todo.assignee))]), _vm._v(" "), _c('b-btn', {
      staticClass: "btn btn-info btn-sm",
      on: {
        "click": function($event) {
          _vm.$root.$emit('show::modal', todo.id.toString())
        }
      }
    }, [_vm._v("Detail")]), _vm._v(" "), _c('b-modal', {
      attrs: {
        "id": todo.id.toString(),
        "title": todo.task
      }
    }, [_c('form', [_c('p', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("Description: " + _vm._s(todo.description))]), _vm._v(" "), _c('p', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("Story Point: " + _vm._s(todo.point))]), _vm._v(" "), _c('p', {
      attrs: {
        "align": "justify"
      }
    }, [_vm._v("Assigned to: " + _vm._s(todo.assignee))]), _vm._v(" "), _c('div', {
      staticClass: "flex-container"
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.remove(todo)
        }
      }
    }, [_vm._v("Delete")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "info"
      },
      on: {
        "click": function($event) {
          _vm.becomeWorkinprogress(todo)
        }
      }
    }, [_vm._v("Change To Work In Progress")])], 1)])])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-481b39e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasktodo.vue
// module id = 189
// module chunks = 1